/**
 * @file ImportDelimiterDropdown.js
 * @description A dropdown component for selecting an import delimiter.
 */

import React, { useState, useEffect } from "react";
import { getImportDelimiters } from "../../../services/importService";
import { Dropdown } from "../../helpers/Dropdown";
import LoadingWrapper from "../../ui/loaders/LoadingWrapper";
import Toast from "../../ui/toasts/Toast";
import { getText } from '../../../i18n';

const ImportDelimiterDropdown = ({
  className,
  inlineLabel = true,
  selectedDelimiter,
  onDelimiterChange,
  required = false,
}) => {
  const [delimiters, setDelimiters] = useState([]);
  const [defaultLabel, setDefaultLabel] = useState("Select Delimiter");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchImportDelimiters = async () => {
      try {
        const data = await getImportDelimiters();
        setDelimiters(data);

        const matchingDelimiter =
          selectedDelimiter &&
          data.find((delimiter) => delimiter.id === selectedDelimiter.id);
        setDefaultLabel(
          matchingDelimiter ? matchingDelimiter.name : "Select Delimiter"
        );
      } catch (error) {
        console.error("Could not fetch import delimiters:", error);
        Toast.error(getText('msg_a18602b8ddad'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchImportDelimiters();
  }, []);

  useEffect(() => {
    if (selectedDelimiter && delimiters.length > 0) {
      const matchingDelimiter = delimiters.find(
        (delimiter) => delimiter.id === selectedDelimiter.id
      );
      setDefaultLabel(
        matchingDelimiter ? matchingDelimiter.name : "Select Delimiter"
      );
    } else {
      setDefaultLabel("Select Delimiter");
    }
  }, [selectedDelimiter, delimiters]);

  const delimiterOptions = [
    { value: null, label: getText('msg_adbe3f44668c') },
    ...delimiters.map((delimiter) => ({
      value: { id: delimiter.id, name: delimiter.name },
      label: delimiter.name,
    })),
  ];

  return (
    <div
      className={`form-group mb-3 ${
        inlineLabel ? "inline-input" : ""
      } ${className}`}
    >
      <label htmlFor="importDelimiter">
        {getText('msg_5e96ff2a317d')}{required && <span className="text-danger">*</span>}
        {/* <span className="text-danger">*</span> */}
      </label>
      <LoadingWrapper isLoading={isLoading}>
        <Dropdown
          defaultValue={defaultLabel}
          options={delimiterOptions}
          onChange={(value) => onDelimiterChange(value)}
          value={selectedDelimiter}
          disabled={delimiters.length === 0 || isLoading}
        />
      </LoadingWrapper>
    </div>
  );
};

export default ImportDelimiterDropdown;
